/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { socialGetSocialQqGroupinfo } from "../../funcs/socialGetSocialQqGroupinfo.js";
import { GetSocialQqGroupinfoRequest$zodSchema } from "../../models/getsocialqqgroupinfoop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetSocialQqGroupinfoRequest$zodSchema,
};

export const tool$socialGetSocialQqGroupinfo: ToolDefinition<typeof args> = {
  name: "social-get-social-qq-groupinfo",
  description: `查询 QQ 群信息

想在你的应用里展示QQ群信息？这个接口让你轻松获取群名称、群头像、群简介、成员数量等详细公开信息。它能帮你快速构建社群导航站、群聊推荐系统，或是为你的数据分析工具提供可靠的数据源。

> [!VIP]
> 本API目前处于**限时免费**阶段，我们鼓励开发者集成和测试。未来，它将转为付费API，为用户提供更稳定和强大的服务。

## 功能概述
你只需要提供一个QQ群号（5-12位纯数字），接口就会返回该群的完整公开信息。我们会先验证群号的有效性，确保返回的数据准确可靠。接口响应速度快，数据结构清晰，非常适合集成到各类应用场景中。

## 返回数据说明
接口会返回以下QQ群的关键信息：

### 基础字段（所有群都有）
- **群基础信息**: 包括群号、群名称，让你能够准确识别和展示群聊
- **视觉素材**: 提供群头像URL（支持多种尺寸），可直接用于在你的界面中展示群聊图标
- **群介绍资料**: 包含群描述/简介和群标签，帮助用户了解群聊的主题和特色
- **便捷入口**: 返回加群链接（二维码URL），方便用户一键加入感兴趣的群聊
- **成员统计**: 当前成员数和最大成员数，直观了解群规模
- **数据时效**: 提供最后更新时间戳，让你了解数据的新鲜度

### 扩展字段（部分群有）
- **活跃度**: 活跃成员数量（可选）
- **群主信息**: 群主QQ号和UID（可选）
- **时间信息**: 建群时间戳和格式化时间（可选）
- **群等级**: 群等级数值（可选）
- **群公告**: 群公告/简介内容（可选）
- **认证信息**: 官方认证类型和说明（可选）

所有返回的数据都遵循标准的JSON格式，字段命名清晰，便于解析和使用。扩展字段仅在数据可用时返回，保持响应体精简。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await socialGetSocialQqGroupinfo(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
